import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { SafePipe } from '../../pipes/safe.pipe';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'calsoft-vedio-layout',
  imports: [DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultStyleDirective, NgClass, DefaultClassDirective, DefaultLayoutGapDirective, MatButton, DefaultFlexDirective, SafePipe],
  templateUrl: './vedio-layout.component.html',
  styleUrl: './vedio-layout.component.scss'
})
export class VedioLayoutComponent {

   public serverPath = environment.commonImageApi + '/home/';

  @Input() img: any;

  @Input() item: any;

  @Input() index: any;
  autoplay:any=0;
  i: any;

   constructor(
    private commonService: CommonService ) {}

  ngOnInit() {

    this.playVideo();
    this.i=this.index  }


  ngAfterViewInit() {
    this.playVideo();
  }

  playVideo() {
    const video = document.querySelector('video') as HTMLVideoElement;
    if (video) {
      if (this.img.autoplay === 1 || this.img.autoplay === 2) {
        video.play();
      }
    }
  }
  

  imageNavigation(id :any){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url :any) {

    this.commonService.goToLink(url)
  }

}
